export const bottomPaginationStyles = {
    paginationContainer: `flex justify-center py-2`,
}